// Keep in sync with HOME_TITLE in pages/index/+Head.tsx and the visible
// body copy. The DB-driven siteConfig.defaultTitle ("Panduan Kafe") is
// too short for SERP — this composed title carries the primary keywords
// already echoed in <main>'s text.
export const title = "Panduan Kafe — Konsultasi & Playbook Cafe yang Untung";
